import { Component, ViewChild, ElementRef } from '@angular/core';
import { NavController, NavParams, Content, ViewController } from 'ionic-angular';
import { AbstractPage } from '../../../_com/abstract-page';
import { ReserveAction } from '../../../../actions/reserve.action';
import { NotebookEditPage } from '../../noteboook/notebook-edit/notebook-edit';

/**
 * Generated class for the InterviewSheetEditStaffPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: "page-notebook-list",
  templateUrl: "notebook-list.html",
})
export class NotebookListPage extends AbstractPage {

  // 子供情報
  // - サンプル
  // {"Child":{"familyId":"61127004a63367be6a543a9e","newChild":false,"name":"太郎","kana":"たろう","gender":"boy","birthday":"2016-03-23T15:00:00.000Z","takuji_keiken_status":"true","allergy_status":"true","sikkan":"true","junyu_status":"false","modified_user":"5ad6ab64a63367582f40221c","modified":"2022-Feb-13 09:36:16","created":"2021-Aug-10 21:25:03","tabetakotoaru_foods":["3","4","5"],"keijyo_yasai":"3","rinyushoku_shokuzai":["jagaimo","ninjin","aona","tamanegi","kyabetsu"],"rinyushoku_tabetakotoaru_shokuzai":["jagaimo","ninjin","aona","kyabetsu","shoyu"],"rinyusyoku_okayu":"5","syokuji_ryo":"2","syokuji_kininaru_tabemura":true,"syokuji_kininaru_asobitabe":true,"seikatsu_rizumu_kisho":"2021-09-26T03:00:00.000Z","sanpo_sanka_status":"true","allergy_text":"2/10 あいうえお","sikkan_sonota_text":"2/10 かきくけこ","konamiruku_text":"2/10 さしすせそ","id":"61127020a63367c06a543a94"}}
  child: any = {};

  data = [];

  @ViewChild(Content) content: Content;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public reserveAction: ReserveAction,
    public viewController: ViewController,
    private el: ElementRef
  ) {
    super();

    // 予約詳細からきた場合
    this.child = this.navParams.data.child.Child;
    super.readyDomAccess(this.el);
  }

  /**
   * 画面が呼び出される前にロード
   */
  ionViewDidLoad() {
    // 受け取った値をセットする
    this.reserveAction
      .getNotebookData({childId: this.child["id"]})
      .subscribe((res) => {
        // ここでデータを取得する
        if (res.data.length > 0) {
          // データ画面に反映
          // {"data":[{"Notebook":{id: "", notebookInfo:{}}]}
          this.data = res.data;
        }
      });
  }

  itemSelected(notebook) {
    // ページ遷移
    this.navCtrl.push(NotebookEditPage, {
      child: this.navParams.data.child,
      notebookId: notebook.id,
      reserveId: notebook.reserveId
    });
  }
  /**
   * キャンセル処理
   */
  cancel() {
    //入力項目タッチ無し
    if (!this.hasTouched()) {
      this.viewController.dismiss();
      return;
    }
    this.viewController.dismiss();
  }

  checkNoData(notebook) {
    if (!notebook) return true;
    if (!notebook.notebookInfo) return true;
    if (!notebook.notebookInfo.taichou && !notebook.notebookInfo.kega) return true;
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/pages/reserve/noteboook/notebook-list/notebook-list.ts